import { render, staticRenderFns } from "./photo-introduce.vue?vue&type=template&id=bbba2e68&scoped=true&"
import script from "./photo-introduce.vue?vue&type=script&lang=js&"
export * from "./photo-introduce.vue?vue&type=script&lang=js&"
import style0 from "./photo-introduce.vue?vue&type=style&index=0&id=bbba2e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbba2e68",
  null
  
)

export default component.exports